// Uses commodity + coordinates so it matches whether the object comes from the
// harvest-alerts list or the marker map.
export const regionMarkerId = (r) =>
  `${(r?.commodityKey || r?.commodity || '').toLowerCase()}|${r?.latitude}|${r?.longitude}`;
